import { Scenarios } from '@jfs/network'

const eventLogging = {
  default: [
    {
      url: /event\/add/,
      method: 'POST',
      response: {
        responseCode: '00',
        responseMessage: 'Request accepted and processed.',
      },
      delay: 500,
    },
  ],
  failed: [
    {
      url: /event\/add/,
      method: 'POST',
      responseCode: 500,
      response: {
        status: 'FAILURE',
        error: {
          message: 'Something went wrong',
          code: '40008',
        },
      },
      delay: 1000,
    },
  ],
} as Scenarios

export { eventLogging }
